import styled from 'styled-components';
import { Body1, Footnote1 } from '../Typography';
import { applyEllipsis, applyNoSelect } from '../../mixins';
import { secondary } from '../../tokens';
import { collectPackageInfo } from '../../collectPackageInfo';
collectPackageInfo('Basebox/Basebox');
export var StyledRoot = /*#__PURE__*/styled.div.withConfig({
  componentId: "plasma__sc-11r48g6-0"
})(["", " position:relative;align-items:flex-start;display:flex;cursor:pointer;"], applyNoSelect);
export var StyledContentWrapper = /*#__PURE__*/styled.label.withConfig({
  componentId: "plasma__sc-11r48g6-1"
})(["position:relative;align-items:flex-start;display:flex;width:100%;cursor:inherit;"]);
export var StyledInput = /*#__PURE__*/styled.input.withConfig({
  componentId: "plasma__sc-11r48g6-2"
})(["position:absolute;&:focus{outline:0 none;}"]);
export var StyledTrigger = /*#__PURE__*/styled.div.withConfig({
  componentId: "plasma__sc-11r48g6-3"
})(["box-sizing:border-box;position:relative;transition:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.lowPerformance ? 'unset' : 'all 0.1s ease-in-out';
});
export var StyledContent = /*#__PURE__*/styled.div.withConfig({
  componentId: "plasma__sc-11r48g6-4"
})(["display:flex;flex-direction:column;margin-left:0.75rem;"]);
export var StyledLabel = /*#__PURE__*/styled(Body1).withConfig({
  componentId: "plasma__sc-11r48g6-5"
})(["", ""], applyEllipsis);
export var StyledDescription = /*#__PURE__*/styled(Footnote1).withConfig({
  componentId: "plasma__sc-11r48g6-6"
})(["color:", ";"], secondary);